<template>
    <div>
        <button type="button" class="btn btn-primary" @click="handleModal()">Purchase</button>

        <template v-if="isSubscribed">
            <b-modal ref="buyModal" size="lg" :title="'Purchase ' + package.credits + ' credit(s)'" :ok-only="true" ok-variant="link" ok-title="Close">
                <template v-if="hardError">
                    <b-alert variant="danger" :show="true" class="mb-2">Sorry, an unknown error has occurred. This sometimes happens if we sell out. Please refresh the page.</b-alert>
                </template>
                <template v-else>

                    <b-alert variant="danger" :show="hasError" class="mb-2">{{ error }}</b-alert>

                    <div class="text-center">
                        <template v-if="paymentMethod">
                            <div class="my-3">

                                <div class="mb-1">
                                    <template v-if="amountToPay == 0">FREE</template>
                                    <template v-else>
                                        £{{ amountToPay }}
                                    </template>
                                </div>

                                <div class="d-inline-block text-center">
                                    <div class="payment-btn-wrapper">
                                <span class="text-monospace ml-3">
                                    <span class="mr-3">{{ paymentMethod.card_type.charAt(0).toUpperCase() + paymentMethod.card_type.slice(1) }}</span>
                                    **** **** **** {{ paymentMethod.last4 }}
                                </span>
                                    </div>

                                    <div class="mb-3 mt-1">
                                        <b-button variant="link" @click="isShowUpdatePaymentMethod = true" v-if="!isShowUpdatePaymentMethod">Update payment method</b-button>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <b-button variant="link" @click="isShowUpdatePaymentMethod = true" v-if="!isShowUpdatePaymentMethod">Update payment method</b-button>
                        </template>
                        <card-update-component
                            v-if="isShowUpdatePaymentMethod"
                            :user="user"
                            :is-inline="true"></card-update-component>

                        <template v-if="paymentMethod">
                            <b-form-checkbox
                                v-model="tandc"
                                name="tandc"
                                value="accepted"
                                unchecked-value="not_accepted"
                                class="my-3">
                                By purchasing credits I consent to PLAYvirtuoso <a href="https://playvirtuoso.com/tandc/" target="_blank" class="text-underline">terms and conditions</a>.
                            </b-form-checkbox>

                            <b-button variant="success" :disabled="isBusy" @click="handlePayment">Buy Now</b-button>
                        </template>
                    </div>
                </template>
            </b-modal>
        </template>
    </div>
</template>

<script>
import {globalEventFire} from "../tracker";

export default {
    props: {
        package: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            stripeAPIToken: document.querySelector('meta[name="stripe-key"]').getAttribute('content'),
            isAuth: false,
            user: {},
            id: null,
            hardError: false,
            hasError: false,
            error: '',
            isBusy: false,
            isFree: false,
            isSubscribed: false,
            isNewlyRegistered: false,
            isFreemiumUser: false,
            isDisabled: false,
            isShowUpdatePaymentMethod: false,
            paymentMethod: null,
            tandc: 'not_accepted',
        }
    },

    computed: {
        // Amount to pay
        amountToPay: function() {
            let amt = 0;

            amt = parseFloat(this.package.price).toFixed(2);

            return amt;
        },
    },

    mounted() {
        // User logged in?
        if(window.virtuoso) {
            if(window.virtuoso.is_auth) {
                this.isAuth = true;
                this.user = window.virtuoso.user;
                this.isFreemiumUser = this.user.isFreemium;
            }
            this.isSubscribed = window.virtuoso.is_subscribed;
        }

        if(!this.isSubscribed) {
            this.isDisabled = true;
        }// Load stripe
        this.includeScript('js.stripe.com/v3/', function(){
            this.configureStripe();
        }.bind(this) );

        this.loadPaymentMethod();

        // When payment methods have been updated refresh that section
        Bus.$on("updatedPaymentMethods", (d) => {
            this.loadPaymentMethod();
            this.isShowUpdatePaymentMethod = false;
        });
    },

    methods: {
        includeScript( URL, callback ){
            let documentTag = document, tag = 'script',
                object = documentTag.createElement(tag),
                scriptTag = documentTag.getElementsByTagName(tag)[0];
            object.src = '//' + URL;
            if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
            scriptTag.parentNode.insertBefore(object, scriptTag);
        },

        /*
            Configures Stripe by setting up the elements and
            creating the card element.
        */
        configureStripe() {
            this.stripe = Stripe( this.stripeAPIToken );
        },

        //
        loadPaymentMethod() {
            // Load payment methods
            this.isBusy = true;
            this.isLoadingPaymentMethods = true;
            axios.get('/api/me/payment_method')
                .then((response) => {
                    this.paymentMethod = response.data;
                    this.isBusy = false;
                });
        },

        // Attempt payment and then enrol
        handlePayment() {
            if(this.tandc == 'not_accepted') {
                this.hasError = true;
                this.error = 'You must accept the terms and conditions to continue.';
            } else {
                this.isBusy = true;
                axios.post('/api/credits/' + this.package.index + '/pay')
                    .then((response) => {
                        if (response.data.success) {
                            this.successfulPaymentRedirect(response.data.payment_id);
                        }

                        if (response.data.error) {
                            this.hasError = true;
                            this.error = response.data.error;
                            this.isBusy = false;
                        }

                        if (response.data.status) {
                            let payment_intent = response.data;

                            if (payment_intent) {
                                const {client_secret, status} = payment_intent;
                                if (status === 'requires_action') {
                                    this.stripe.confirmCardPayment(client_secret).then((result) => {
                                        if (result.error) {
                                            // Display error message in your UI.
                                            // The card was declined (i.e. insufficient funds, card has expired, etc)
                                            this.hasError = true;
                                            this.error = result.error.message;
                                            this.isBusy = false;
                                        } else {
                                            // Redirect after a timeout to give the webhook time to run
                                            this.successfulPaymentRedirect(response.data.payment_id);
                                        }
                                    });
                                } else if (status === 'succeeded') {
                                    this.successfulPaymentRedirect(response.data.payment_id);
                                } else {
                                    this.hasError = true;
                                    this.error = 'An error was encountered.  Error code #FAS2135';
                                }
                            }
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.hasError = true;
                        this.error = 'An unexpected error occured.';
                        this.isBusy = false;
                    });
            }
        },

        // When payment is successful redirect after firing analytics
        successfulPaymentRedirect(payment_id) {
            // Fire success
            this.fireAnalytics(payment_id);

            setTimeout(() => {
                location.href = '/credits/purchase/' + this.package.index + '/success';
            }, 1500);
        },

        // Fire analytics
        fireAnalytics(enrolment_id) { // enrolment_id is payment_id
            globalEventFire('Purchase', 'VOD', {
                'item_id': this.package.index,
                'category': 'Credits',
                'name': this.package.credits + ' Credits Package',
                'num_items': 1,
                'amount': this.amountToPay,
                'enrolment_id': enrolment_id,
            });
        },

        // Clicked
        handleModal() {
            this.$refs['buyModal'].show('buyModal');
        },
    }
}
</script>
